// Stream Chat library i18n setup — registers vi/pl/tl/ar/zh translation packs
// (fr is shipped built-in by stream-chat-react) and keeps the library language
// in sync with our app's preferredLanguage.
import { Streami18n } from 'stream-chat-react'
import 'dayjs/locale/ar'
import 'dayjs/locale/fr'
import 'dayjs/locale/pl'
import 'dayjs/locale/vi'
import 'dayjs/locale/zh-cn'
import tlPhDayjs from 'dayjs/locale/tl-ph'

import arTranslations from './streamChatLocales/ar.json'
import plTranslations from './streamChatLocales/pl.json'
import tlTranslations from './streamChatLocales/tl.json'
import viTranslations from './streamChatLocales/vi.json'
import zhTranslations from './streamChatLocales/zh.json'
import type { SupportedLanguage } from './index'

// `stream-chat-react@10.7.6` ships built-in packs for: de, en, es, fr, hi, it, ja, ko, nl, pt, ru, tr.
// Our app supports ar/en/es/fr/pl/tl/vi/zh — en/es/fr use built-ins; ar/pl/tl/vi/zh are registered here.
// Tagalog reuses Day.js's `tl-ph` locale config so date/time formatting works under the `tl` key.
export const streamChatI18n = new Streami18n({ language: 'en' })

streamChatI18n.registerTranslation('ar', arTranslations as any)
streamChatI18n.registerTranslation('pl', plTranslations as any)
streamChatI18n.registerTranslation('tl', tlTranslations as any, tlPhDayjs)
streamChatI18n.registerTranslation('vi', viTranslations as any)
streamChatI18n.registerTranslation('zh', zhTranslations as any)

const STREAM_LANGUAGE_MAP: Record<SupportedLanguage, string> = {
  ar: 'ar',
  en: 'en',
  es: 'es',
  fr: 'fr',
  pl: 'pl',
  tl: 'tl',
  vi: 'vi',
  zh: 'zh',
}

export const setStreamChatLanguage = (lang: SupportedLanguage) => {
  // Fire-and-forget; Streami18n debounces internally and resolves once the language is loaded.
  void streamChatI18n.setLanguage(STREAM_LANGUAGE_MAP[lang] as any)
}
